import { useState, useEffect } from 'react'
import { passwordChange } from '../../../redux/actions/auth'
import { connect } from 'react-redux'
import { Navigate, useNavigate } from 'react-router-dom'
import styles from './ChangePasswordForm.module.css';
import form from '../../../styles/shared/FormDialog.module.css';
import dialog from '../../../styles/shared/Dialog.module.css';

const ChangePasswordForm = ({ passwordChange, error, user }) => {
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [formData, setFormData] = useState({
    password: '',
    passwordNew: '',
  })
  const [submitError, setSubmitError] = useState('')
  const [submitSuccess, setSubmitSuccess] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const { password, passwordNew } = formData
  const [passwordValidate, setPasswordValidate] = useState('')

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
    if (submitError) setSubmitError('')
  }

  // Volver a la pantalla anterior; si se entró directo por URL, a la portada
  const onCancel = () => {
    if (window.history.state?.idx > 0) navigate(-1)
    else navigate('/landing')
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (!password || !passwordNew || !passwordValidate) {
      setSubmitError('Por favor, ingresa la contraseña actual, la nueva y su confirmación.')
      return
    }
    if (passwordNew !== passwordValidate) {
      setSubmitError('Las contraseñas nuevas no coinciden. Por favor, ingrésalas otra vez.')
      return
    }
    setSubmitting(true)
    try {
      const result = await passwordChange(user?.id, password, passwordNew, passwordValidate)
      if (result.success) {
        window.scrollTo(0, 0)
        setSubmitError('')
        setSubmitSuccess('Su contraseña ha sido cambiada con éxito.')
      } else {
        setSubmitSuccess('')
        setSubmitError(result.message || 'Credenciales inválidas. Por favor, inténtalo de nuevo.')
      }
    } catch (err) {
      setSubmitError('Error al cambiar contraseña. Por favor, inténtalo de nuevo.')
    } finally {
      setSubmitting(false)
    }
  }
  if (submitSuccess !== '') {
    return <Navigate to='/landing' />
  }

  const message = submitError || error

  return (
    <div className={styles.page}>
      <section className={styles.card} aria-labelledby='change-password-title'>
        <h2 id='change-password-title' className={`${form.formTitle} ${styles.title}`}>Cambiar contraseña</h2>
        <p className={styles.subtitle}>Ingresa tu contraseña actual y luego la nueva dos veces.</p>
        <form onSubmit={onSubmit} className={form.form} noValidate>
          <div className={form.field}>
            <label htmlFor='password' className={form.label}>Contraseña actual</label>
            <input
              id='password'
              name='password'
              type='password'
              className={form.formInput}
              autoComplete='current-password'
              value={password}
              onChange={onChange}
            />
          </div>
          <div className={form.field}>
            <label htmlFor='passwordNew' className={form.label}>Contraseña nueva</label>
            <input
              id='passwordNew'
              name='passwordNew'
              type='password'
              className={form.formInput}
              autoComplete='new-password'
              value={passwordNew}
              onChange={onChange}
            />
          </div>
          <div className={form.field}>
            <label htmlFor='passwordValidate' className={form.label}>Repetir contraseña nueva</label>
            <input
              id='passwordValidate'
              name='passwordValidate'
              type='password'
              className={form.formInput}
              autoComplete='new-password'
              value={passwordValidate}
              onChange={(event) => {
                setPasswordValidate(event.target.value)
                if (submitError) setSubmitError('')
              }}
            />
          </div>
          {message && <p className={form.formError} role='alert'>{message}</p>}
          <div className={`${dialog.buttons} ${form.buttons}`}>
            <button type='button' className={dialog.cancelButton} onClick={onCancel}>Cancelar</button>
            <button type='submit' className={dialog.confirmButton} disabled={submitting}>
              {submitting ? 'Guardando...' : 'Guardar cambios'}
            </button>
          </div>
        </form>
      </section>
    </div>
  )
}
const mapStateToProps = (state) => ({
  loading: state.Auth.loading,
  error: state.Auth.error,
  user: state.Auth.user,
})

export default connect(mapStateToProps, { passwordChange })(ChangePasswordForm)
